import { Component } from '@angular/core';
import { UtilService } from '../../../services/util.service';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { Router } from '@angular/router';
import { Constants } from '../../../constants/constants';
import { ParametrizacionService } from '../../../services/parametrizacion.service';
import { firstValueFrom } from 'rxjs';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {

  private readonly CMS_ROUTE = 'cms';

  infoPantalla: InfoPantallaDTO = {};
  constructor(
    private utilService: UtilService,
    private router: Router,
    private parametrizacion: ParametrizacionService
  ) {
    this.infoPantalla = this.utilService.infoPantalla.getValue();
    // Información de la pantalla y guía interactiva
    this.utilService.watchInfoPantalla().subscribe((info: InfoPantallaDTO) => {
      if (info) {
        this.infoPantalla = info;
      }
    });
  }

  async navegar(url: string, isInicio = false) {
    const isLogged = sessionStorage.getItem(Constants.IS_SUCCESS_LOGIN) === '1';

  if (url === this.CMS_ROUTE) {
    const parametro = await firstValueFrom(
      this.parametrizacion.obtenerParametrizacionUrlCms()
    );

    window.location.href = parametro.valor_parametro;
    return;
  }

    if (this.infoPantalla.change) {
      if(isLogged && isInicio){
        await this.infoPantalla.change(() => {
          this.router.navigate(['/']);
        });
      }else{
        await this.infoPantalla.change(() => {
          this.router.navigateByUrl(url);
        });
      }
    } else {
      if(isLogged && isInicio){
        await this.router.navigate(['/']);
      }else{
        await this.router.navigateByUrl(url);
      }
    }
  }

  closeMenu() {
    const navbarCollapse = document.querySelector('.navbar-collapse');
    const iconNavbarCollapsed = document.querySelector('.navbar-toggler');

    if (navbarCollapse?.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }

    if (iconNavbarCollapsed?.getAttribute('aria-expanded') === 'true') {
      iconNavbarCollapsed.setAttribute('aria-expanded', 'false');
    }
  }
}
